import { render, staticRenderFns } from "./AdditionalInformationModal.vue?vue&type=template&id=fa1c47fc&"
import script from "./AdditionalInformationModal.vue?vue&type=script&lang=js&"
export * from "./AdditionalInformationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports